import { PureComponent, ReactNode } from 'react';
import PadV2PxElementCard from '../../rightPanel/workspace/padV2/PadV2PxElementCard';
import { DentalProcedureIcon } from '../../../common/Icons';
import { DentalProcedureOnPadAutoSuggest } from './DentalProcedure/DentalProcedureAutoSuggest';
import PadV2DentalProcedureTable from './DentalProcedure/DentalProcedureTable';

export const DENTAL_PROCEDURE_AS_INPUT = 'DENTAL_PROCEDURE_AS_INPUT';
export const DENTAL_PROCEDURE_AS_EL_ID = 'DENTAL_PROCEDURE_AS_EL_ID';
export const DENTAL_PROCEDURE_CONTAINER = 'DENTAL_PROCEDURE_CONTAINER';

class DentalProcedure extends PureComponent {
    DentalProcedureIcon = DentalProcedureIcon();

    render(): ReactNode {
        const { DentalProcedureIcon } = this;

        return (
            <PadV2PxElementCard
                icon={DentalProcedureIcon}
                headingText={'Dental Procedures'}
                iconContainerBgClassName="bg-darwin-accent-medicines-pink-800"
                bodyCssClassName="space-y-8 rounded-b-8"
                id={DENTAL_PROCEDURE_CONTAINER}
            >
                <PadV2DentalProcedureTable />
                <DentalProcedureOnPadAutoSuggest />
            </PadV2PxElementCard>
        );
    }
}
export default DentalProcedure;
